export const environment = {
  production: true,
  strapiBaseUrl: 'https://pro-admin.concilio.com',
  cookieDomain: 'pro.concilio.com',
};
